module.exports = __webpack_public_path__ + "img/logo.130c8d01.png";